import {
    Flex, Heading, Spinner, Text,
} from '@chakra-ui/react';
import { useBrowserTitle } from '@acp/core-ui';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

export function AuthLogout() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    useBrowserTitle('Logout');

    useEffect(() => {
        const logoutUrl = params.get('logout_url');
        if (logoutUrl === null) {
            navigate('/auth/login');
            return;
        }

        window.location.assign(logoutUrl);
    }, [params]);

    return (
        <Flex flexDir="column" width="100%">
            <Flex width="100%" alignItems="center" mb={6}>
                <Heading fontSize="3xl" flexGrow={1}>
                    We&apos;re signing you out...
                </Heading>
                <Spinner />
            </Flex>
            <Text fontSize="lg">Please wait while we redirect you</Text>
        </Flex>
    );
}
